import { Component, h, Host, Event, EventEmitter } from '@stencil/core';

@Component({
  tag: 'ui-bank-search-error',
  styleUrl: 'ui-bank-search-error.scss',
})
export class UiBankSearchError {
  @Event({ eventName: 'errorClose' }) errorCloseEvent: EventEmitter;

  emitCloseEvent() {
    this.errorCloseEvent.emit();
  }

  render() {
    return (
      <Host>
        <div class="errormessage">
          <sd-button
            aria-label="Fehlermeldung schließen"
            onClick={this.emitCloseEvent.bind(this)}
            inverted
            variant="tertiary"
            size="sm"
          >
            <sd-icon
              library={(window as any).ui.cmsState?.iconLibrary}
              name="union-investment/system/close"
            ></sd-icon>
          </sd-button>
          <p class="sd-paragraph sd-paragraph--inverted">
            <slot></slot>
          </p>
        </div>
      </Host>
    );
  }
}
